/* eslint camelcase: "off" */

import { cdncv_playinfo, cdn_playstatus } from 'amkit3-modules/utils/services/statistic/cdnstats'
import { video_quality_kadun } from 'amkit3-modules/utils/services/statistic/huya/metric'

import StatisticEvent from './statistic-event'
// import cookie from 'amkit3-modules/utils/cookie'

class CDNStatistic {
  constructor (collector) {
    collector.on(StatisticEvent.PLAYBACK_PROGRESS, () => {
      cdncv_playinfo(collector.getCDN(), collector.getVid(), collector.getCDNURL(), 'success', '1', JSON.stringify({ h5: 1 }))
      video_quality_kadun(
        collector.getYYUId(),
        collector.getSessionId(),
        collector.getMId(),
        collector.getVid(),
        global.location.href,
        '0',
        collector.getCDNURL(),
        collector.getOS(),
        collector.getSre(),
        'success',
        collector.getCDN(),
        ''
      )
    })
    collector.on(StatisticEvent.PLAYBACK_PROGRESS_ERROR, () => {
      var errorMessage = collector.getCDNError()
      if (errorMessage && (errorMessage.indexOf('MEDIA_ERR_ABORTED') >= 0 ||
        errorMessage.indexOf('MEDIA_ERR_DECODE') >= 0 ||
        errorMessage.indexOf('MEDIA_ERR_SRC_NOT_SUPPORTED') >= 0)) return

      var remark = JSON.stringify({
        h5: 1,
        ua: collector.getUserAgent(),
        session_id: collector.getSessionId(),
        page_id: collector.getPageId(),
        os: collector.getOS()
      })
      cdncv_playinfo(collector.getCDN(), collector.getVid(), collector.getCDNURL(), collector.getCDNError(), '-1', remark)
      video_quality_kadun(
        collector.getYYUId(),
        collector.getSessionId(),
        collector.getMId(),
        collector.getVid(),
        global.location.href,
        '0',
        collector.getCDNURL(),
        collector.getOS(),
        collector.getSre(),
        'failure',
        collector.getCDN(),
        remark
      )
    })
    collector.on(StatisticEvent.PLAYBACK_VV, () => {
      cdn_playstatus(collector.getCDN(), '1', JSON.stringify({ h5: 1 }))
    })
    collector.on(StatisticEvent.PLAYBACK_VV_ERROR, () => {
      var errorMessage = collector.getCDNError()
      if (errorMessage && (errorMessage.indexOf('MEDIA_ERR_ABORTED') >= 0 ||
        errorMessage.indexOf('MEDIA_ERR_DECODE') >= 0 ||
        errorMessage.indexOf('MEDIA_ERR_SRC_NOT_SUPPORTED') >= 0)) return

      cdn_playstatus(collector.getCDN(), '-1', JSON.stringify({
        h5: 1,
        url: collector.getCDNURL(),
        msg: collector.getCDNError()
      }))
    })
  }
}

export default CDNStatistic
